import React, { useContext } from 'react'
import PaymentButton from 'app/React/Components/Footer/PaymentButton'
import StepIsValid from 'app/React/Components/misc/StepIsValid'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SubmitButton({ prefix, text, buttonText, onClick = () => {}, isPaymentButton = false }) {
  const { currentStep } = useContext(ConfiguratorContext)

  if (typeof onClick !== 'function' || text === '') {
    return null
  }

  return (
    <div className='form-submit'>
      <div className='form-submit__inner'>
        <p className='form-submit__text'>
          {prefix && <strong>{prefix}:</strong>}
          <span>{text}</span>
        </p>

        <StepIsValid step={currentStep}>
          {
            isPaymentButton
              ? <PaymentButton
                classes='form-submit__button'
                button_text={buttonText}
              />
              : <button
                className='form-submit__button'
                onClick={onClick}
              >
                {buttonText}
              </button>
          }
        </StepIsValid>
      </div>
    </div>
  )
}
